// Whether the network's extension filter lets a file extension into the file
// module. The filter is enforced in the file servers; this is what keeps a
// blocked extension out of the interface in the first place, in the upload
// field and in the form for a new document (tixxt/core#258).
//
// Only `extension_filter_enabled` counts here, exactly as in the file servers.
// `extension_filter_available` decides whether the setting is offered in the
// administration at all and is deliberately not part of the check: a network
// where the feature was taken away while the filter was on is still filtered
// server side, and the interface has to say so.
export default function extensionAllowed(extension?: string): boolean {
  if (!Preload.current_network.files.extension_filter_enabled) return true;

  const filterList = Preload.current_network.files.extension_filter_list;
  const listed = filterList.includes(extension?.toLowerCase() as string);

  switch (Preload.current_network.files.extension_filter_type) {
    case "allow":
      return listed;
    case "deny":
      return !listed;
    default:
      return true;
  }
}
